import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import parse from 'html-react-parser';

import "../App.css"

import { useTranslation } from 'react-i18next'

// components
import GlobalHeaader from '../components/GlobalHeader';
import GlobalFooter from '../components/GlobalFooter';
import BreadcrumbTrail from '../components/BreadcurmbTrail';
import Menu from '../components/Menu';
import ReportProblem from '../components/ReportProblem';

import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

// utils
import { getTranslatedText } from './utils_v2/kumuHelper';

// actions
import { getElements } from '../api/blawksAPI'
// constants

export default function OverviewPage() {

    const { t, i18n } = useTranslation('translation');
    const { id } = useParams();

    const [element, setElement] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const kumuElements = require('../api/kumu_elements.json');
    const navigate = useNavigate()

    useEffect(() => {
        // getElements('CSmith109', 'map-tool-21').then(res => {
        //     const result = res.rows.filter((elm) => elm.value.attributes['element type'] === 'result').filter(result => result.value.attributes['reference id'].replace(/\s+/g, '') === id)
        //     if (result.length === 1) {
        //         setElement(result[0])
        //     }
        //     setIsLoading(false)
        // })
        const result = kumuElements.rows.filter((elm) => elm.value.attributes['element type'] === 'result').filter(result => result.value.attributes['reference id'].replace(/\s+/g, '') === id)
        if (result.length === 1) {
            setElement(result[0])
        }
        setIsLoading(false)
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const getData = (data) => (data !== undefined && data !== "") ? parse(data) : t("Not available")

    function stripHtml(htmlString) {
        const doc = new DOMParser().parseFromString(htmlString, 'text/html');
        return doc.body.textContent || "";
    }

    return (
        <div>
            <header>
                <GlobalHeaader />
                <Menu />
                <BreadcrumbTrail />
            </header>

            {isLoading ?
                <main property="mainContentOfPage" className="page-content container" typeof="WebPageElement">
                    <Stack>
                        <Skeleton variant="text" height={75} width={400} />
                        <Skeleton variant="text" height={90} />
                        <Skeleton variant="text" height={75} />
                    </Stack>
                </main> :
                <main property="mainContentOfPage" className="page-content container" typeof="WebPageElement">
                    <h1 id="wb-cont"><i>{getTranslatedText(i18n.language, stripHtml(element.value.attributes.label))}</i></h1>
                    <br/>
                    <h2>{t('Program Website')}</h2>
                    <section>
                        <p>{i18n.language === 'fr' ? getData(element.value.attributes['program website fr']) : getData(element.value.attributes['program website'])}</p>
                    </section>
                    <br/>
                    <h2>{t('How to Apply or Report')}</h2>
                    <section>
                        <p>{i18n.language === 'fr' ? getData(element.value.attributes['where to apply fr']) : getData(element.value.attributes['where to apply'])}</p>
                    </section>
                    <br/>
                    <h2>{t('Timelines')}</h2>
                    <section>
                        <p>{i18n.language === 'fr' ? getData(element.value.attributes['timelines fr']) : getData(element.value.attributes['timelines'])}</p>
                    </section>
                    <br/>
                    <h2>{t('Application and Regulatory Guidance')}</h2>
                    <section>
                        <p>{i18n.language === 'fr' ? getData(element.value.attributes['guidance fr']) : getData(element.value.attributes['guidance'])}</p>
                    </section>
                    <br/>
                    <h2>{t('Application Examples')}</h2>
                    <section>
                        <p>{i18n.language === 'fr' ? getData(element.value.attributes['examples fr']) : getData(element.value.attributes['examples'])}</p>
                    </section>
                    <br/>
                    <h2>{t('Contact Information')}</h2>
                    <section>
                        <p>{i18n.language === 'fr' ? getData(element.value.attributes['contact fr']) : getData(element.value.attributes['contact'])}</p>
                    </section>
                    <button
                        className="btn btn-default wide-button"
                        onClick={(e) => navigate('..')}
                        >
                        <span>
                            <h6 style={{ margin: 0 }}>{t('Back')}</h6>
                        </span>
                    </button>
                </main>}
                

            <ReportProblem />
            <GlobalFooter />
        </div>
    );
}